import { Container, Image } from "@mantine/core";
import { useEffect, useState } from "react";
// import useGetProjetoItem from "./useGetProjeto";

const MAGIC_NUMBER = 20;

// prettier-ignore
const BannerComponent = ({ projeto, tipo }: { projeto: TProjeto | null | undefined, tipo: string }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    if (projeto && projeto.posicao === tipo && projeto.images && projeto.images.length > 0 && projeto.trocar) {
      const intervalId = setInterval(() => {
        setCurrentImageIndex(previousIndex => (previousIndex + 1) % projeto.images.length);
      }, projeto.tempo); // Troca de imagem a cada 5000ms (5 segundos)

      return () => clearInterval(intervalId);
    }
    return undefined;
  }, [projeto, tipo]);

  const safeImageAccess = projeto?.images && currentImageIndex < projeto.images.length ? projeto.images[currentImageIndex] ?? null : null;

  const marginTop = tipo === "1" ? 0 : MAGIC_NUMBER;

  return projeto && projeto.posicao === tipo ? <Container onClick={onOpen(projeto, currentImageIndex)} fluid h={"15vh"} w={"100vw"} p={0} style={{ marginTop }}>
    <Image
      h={"15vh"}
      src={safeImageAccess?.path}
    />
  </Container> : <></>
};

export default BannerComponent;

const onOpen = (projeto: TProjeto | null | undefined, currentImageIndex: number) => {
  const safeImage =
    projeto?.images && currentImageIndex < projeto.images.length ? (projeto.images[currentImageIndex] ?? null) : null;
  return () => {
    const imageUrl = projeto?.urlImages?.find((item) => item.path === safeImage?.name);
    if (imageUrl?.url) {
      window.open(imageUrl.url);
    }
  };
};
